/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './ErrorView.scss';
import {useDispatch} from 'react-redux';
import {sendError} from '../../common/redux/actions';
import {CodeErrors} from '../../common/const/const'


const ErrorMessage = {
    [CodeErrors.UserNotExistError]: 'Пользователь не существует',
    [CodeErrors.AuthCodeNotValidError]: 'Неверный код',
    [CodeErrors.AuthorizationRequiredError]: 'Ошибка авторизации',
    [CodeErrors.RefreshTokenNotValid]: 'Ключ авторизации устарел',
    [CodeErrors.ArchiveUploadingError]: 'Ошибка загрузки',
    [CodeErrors.InvalidArchiveExtensionError]: 'Неверный формат файла\nВыберите ZIP-архив',
    [CodeErrors.InternalServerError]: 'Ошибка сервера'
}


const ErrorView = ({error}) => {
    const title = 'message' in error ? error.message : ErrorMessage[error.errorCode];
    const message = 'message' in error ? '' : error.errorMessage;
    const dispatch = useDispatch();

    const onClick = React.useCallback(() => {
        dispatch(sendError(undefined))
    }, [dispatch]);

    return (
        <div tabinndex={0} onClick={onClick} role="banner"  className="ErrorView">
            <h2 className="ErrorView__title">{title}</h2>
            <span className="ErrorView__message">{message}</span>
        </div>
    )
}

export default ErrorView
